import React from "react";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";

const SeoAddressLayout = ({
	children,
	classes,
	topComponent,
	middleComponent,
	bottomComponent,
}) => {
	return (
		<Container
			style={{
				backgroundColor: "#f5f7fa",
				margin: "0 auto",
				padding: "0",
			}}
		>
			<Row>
				<Col>{topComponent}</Col>
			</Row>
			<Row>
				<Col>{middleComponent}</Col>
			</Row>
			<Row>
				<Col>{bottomComponent}</Col>
			</Row>
		</Container>
	);
};
export default SeoAddressLayout;
